// Persistent low-weight brand + analytics consent line.
// "This site uses analytics cookies." satisfies the user-decided UK ICO
// implied-consent pattern for non-essential cookies (Mixpanel). The Privacy
// link is the escape valve.

export default function Footer() {
  return (
    <footer className="bg-paper border-t border-border py-6 text-[12px] text-ink-mute">
      <div className="max-w-[1180px] mx-auto px-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <a href="https://www.sagentivum.com/" className="font-display font-semibold text-green-700 hover:underline">Sagentivum</a>
          <span className="mx-2 text-stone-400">·</span>
          <span>Structural strategy for AI-era organisations.</span>
        </div>
        <div className="flex items-center gap-4">
          <span>This site uses analytics cookies.</span>
          <a
            href="/privacy"
            className="border-b border-border-strong hover:text-green-700 hover:border-green-700"
          >
            Privacy
          </a>
        </div>
      </div>
    </footer>
  );
}
